import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  InputType,
  ValidationRule,
} from "../services/types/ComponentTypes";

export const screen_152_vehicle_type: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Vehicle type",
    style: {},
    childComponents: [
      {
        componentType: LayoutTypes.FORM,
        Name: "vehicletype",
        TableName: "lookup_name",
        DisplayName: "Vehicle type",
        columnNumber: "m1 t1 w1",
        style: {
          padding: 10,
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
        },
        Fields: [
          {
            componentType: ComponentType.TEXT_FIELD,
            IncludeLabel: true,
            Label: "Name",
            name: "txt_name",
            BindValue: "txt_name",
            Json_Attribute: "name",
            IsReadOnly: false,
            inputType: InputType.TEXT,
            showInSummary: true,
            IsVerticalView: true,
          },
          {
            componentType: LayoutTypes.GROUP,
            style: {
              direction: FlexDirection.ROW,
              gap: 10,
              marginTop: 10,
            },
            childComponents: [
              {
                componentType: ComponentType.BUTTON,
                name: "Submit",
                Label: "Submit",
                BindValue: "btn_submit",
                onPressAction: "save",
                ActionType: "Add",
                ScreenId: "152",
                style: {
                  backgroundColor: "#22c55e",
                  textColor: "#FFFFFF",
                  padding: "12px 24px",
                  borderRadius: 8,
                },
              },
              // {
              //   componentType: ComponentType.BUTTON,
              //   name: "Cancel",
              //   Label: "Cancel",
              //   onPressAction: "navigate_back",
              //   style: {
              //     backgroundColor: "#6b7280",
              //     textColor: "#FFFFFF",
              //     padding: "12px 24px",
              //     borderRadius: 8,
              //   },
              // },
            ],
          },
          {
            componentType: ComponentType.SUB_MODULE,
            name: "vehicletype_items",
            label: "Items",
            tableName: "lookup_items",
            BindValue: "sub_lookupitem",
            addButtonPosition: "top",
            enableSearch: true,
            childControls: [
              {
                IncludeLabel: true,
                Label: "Vehicle make",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "vehicle_make",
                Json_Attribute: "related_id",
                componentType: ComponentType.SEARCHABLE_DROPDOWN,
                LookupName: "vehicle_make",
                IsVerticalView: true,
                showInSummary: false,
              },
              {
                IncludeLabel: true,
                Label: "Vehicle type",
                PlaceHolder: "",
                IsMandatory: false,
                BindValue: "txt_subName",
                Json_Attribute: "name",
                componentType: ComponentType.TEXT_FIELD,
                showInSummary: false,
                IsReadOnly: false,
                IsVerticalView: true,
                inputType: InputType.TEXT,
              },
            ],
          },
        ],
      },
    ],
  },
];
